export default __webpack_public_path__ + "static/6918-ad547cf0bfe7d818ef205105c69e14ce.jpg";